import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue'
import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import HeaderComponent from '@/components/Header/HeaderComponent.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SsoUnpaidView',
  setup(__props) {

async function redirectToService() {
  window.location.replace(process.env.VUE_APP_SSO_UNPAID)
}

onMounted(() => {
  store.commit(`${ModuleNamespaces.SPINNER}/SHOW_SPINNER`, true)
  redirectToService()
})

return { __sfc: true,redirectToService, HeaderComponent }
}

})